/* Forest — a liquid glass stíluslap beemelése az UpCart shadow rootjába.
 *
 * MIÉRT KELL EGYÁLTALÁN JS. Az UpCart `renderCartInShadowDom: true`-val fut
 * (mérve 2026-08-26 a build témán), és a fiókot egy `mode:"open"` shadow rootba
 * rendereli. A lapszintű CSS ODA NEM ÉR BE — az egyéni tulajdonságok igen
 * (azok öröklődnek), de osztályra célzott szabály nem. A drl-upcart-glass.css
 * túlnyomó része osztályra céloz, tehát be kell juttatni.
 *
 * MIÉRT AZ attachShadow FOLTOZÁSA. A shadow root a bundle futásakor jön létre,
 * ami a </body> előtti `defer` script — ez a fájl a <head>-ben van, szintén
 * `defer`, tehát a dokumentumsorrend miatt ELŐBB fut. Nincs mit megvárni és
 * nincs mit pollozni: a foltozott attachShadow pontosan abban a pillanatban
 * teszi be a lapot, amikor a root megszületik, még mielőtt a React bármit
 * renderelne bele. Így nincs stílus nélküli villanás.
 *
 * A <link> a lapon már be van töltve (theme.liquid preload), tehát a klón a
 * gyorsítótárból jön — hálózati kör nélkül.
 */
(function () {
  var self = document.currentScript;
  var href = self && self.dataset && self.dataset.css;
  if (!href) return;

  function inject(root) {
    if (!root || root.getElementById('drl-upcart-glass')) return;
    var link = document.createElement('link');
    link.id = 'drl-upcart-glass';
    link.rel = 'stylesheet';
    link.href = href;
    root.appendChild(link);
    // Az app a root létrejötte UTÁN fűzi be a saját stíluslapját és a
    // customCSS-ét. A !important a legtöbb szabályunkat megvédi, de ahol nincs,
    // ott a dokumentumsorrend dönt — egy rAF-fel a végére tesszük magunkat.
    // Ugyanannak a csomópontnak az appendChild-ja MOZGATÁS, nem másolat.
    requestAnimationFrame(function () { root.appendChild(link); });
  }

  var host = document.getElementById('upCart');
  if (host && host.shadowRoot) { inject(host.shadowRoot); return; }

  var native = Element.prototype.attachShadow;
  Element.prototype.attachShadow = function (init) {
    var root = native.call(this, init);
    if (this.id === 'upCart') {
      Element.prototype.attachShadow = native;   // egyszer kell, utána visszaadjuk
      try { inject(root); } catch (e) {}
    }
    return root;
  };
})();
